let tokenGetter: (() => Promise<string | null>) | null = null;

export function registerTokenGetter(getter: () => Promise<string | null>) {
  tokenGetter = getter;
}

export async function getAccessToken(): Promise<string | undefined> {
  if (!tokenGetter) {
    return undefined;
  }
  try {
    const token = await tokenGetter();
    return token || undefined;
  } catch {
    return undefined;
  }
}
